export function getErrorMessage(error: unknown): string | null {
  if (!error) return null;

  const baseMessage = error instanceof Error ? error.message : 'An error occurred';

  if (__DEV__) {
    const details: string[] = [];
    if (typeof error === 'object' && error !== null) {
      const err = error as Record<string, unknown>;
      if (err.status) details.push(`Status: ${err.status}`);
      if (err.statusText) details.push(String(err.statusText));
      if (
        typeof err.data === 'object' &&
        err.data !== null &&
        'message' in (err.data as Record<string, unknown>)
      ) {
        details.push(`Server: ${(err.data as Record<string, unknown>).message}`);
      }
    }
    if (details.length > 0) {
      return `${baseMessage}\n\n${details.join('\n')}`;
    }
  }

  return baseMessage;
}
